import React from "react"
import {LoginPanel} from './panels/login'
import {ForgottenPasswordPanel} from './panels/forgot_password'
import {trackEventSP} from 'js/studios/shared/tracking'


const PANELS = {
  'login': LoginPanel,
  'forgot-password': ForgottenPasswordPanel,
}

export class AuthForm extends React.Component {
  state = { panel: 'login' }

  componentDidMount(){
    trackEventSP('Sign up or log in modal displayed', 'Customer sign up', { panel: this.state.panel })
  }

  navigateToPanel = (panel) => {
    this.setState({ panel: panel })
  }

  render(){
    const PanelClass = PANELS[this.state.panel]

    return <PanelClass navigateToPanel={this.navigateToPanel} onSuccess={this.props.onSuccess} />
  }
}
